import React, { useState } from 'react';

import { DataTableAction } from 'components/DataTable';
import { ENTITY_NOTE } from 'constants/schemas';
import NewNoteDialog from 'components/NewNoteDialog';
import { NoteIcon } from 'constants/icon.constants';
import PropTypes from 'prop-types';
import { formatType } from 'utils/entity.utils';

function ActionAddNote(props) {
  const { initState } = props;
  const [dialogOpen, setDialogOpen] = useState(false);
  const isTemplate = initState?.is_template;
  return (
    <>
      <DataTableAction
        label={`New ${formatType(ENTITY_NOTE, { template: isTemplate })}`}
        icon={<NoteIcon colored template={isTemplate} />}
        onClick={() => setDialogOpen(true)}
      />
      <NewNoteDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        initState={initState}
      />
    </>
  );
}

ActionAddNote.propTypes = {
  initState: PropTypes.object,
};

export default ActionAddNote;
